/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductData } from './ProductData';
import {
    ProductDataFromJSON,
    ProductDataFromJSONTyped,
    ProductDataToJSON,
    ProductDataToJSONTyped,
} from './ProductData';
import type { ProductAssortmentSummaryData } from './ProductAssortmentSummaryData';
import {
    ProductAssortmentSummaryDataFromJSON,
    ProductAssortmentSummaryDataFromJSONTyped,
    ProductAssortmentSummaryDataToJSON,
    ProductAssortmentSummaryDataToJSONTyped,
} from './ProductAssortmentSummaryData';
import type { ProductPublicationReadMetadata } from './ProductPublicationReadMetadata';
import {
    ProductPublicationReadMetadataFromJSON,
    ProductPublicationReadMetadataFromJSONTyped,
    ProductPublicationReadMetadataToJSON,
    ProductPublicationReadMetadataToJSONTyped,
} from './ProductPublicationReadMetadata';

/**
 * 
 * @export
 * @interface ProductAssortmentData
 */
export interface ProductAssortmentData {
    /**
     * 
     * @type {ProductAssortmentSummaryData}
     * @memberof ProductAssortmentData
     */
    summary?: ProductAssortmentSummaryData;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof ProductAssortmentData
     */
    products?: Array<ProductData>;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof ProductAssortmentData
     */
    topProducts?: Array<ProductData>;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentData
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentData
     */
    totalPages?: number;
    /**
     * 
     * @type {ProductAssortmentDataModeEnum}
     * @memberof ProductAssortmentData
     */
    mode?: ProductAssortmentDataModeEnum;
    /**
     * 
     * @type {ProductAssortmentDataSortByEnum}
     * @memberof ProductAssortmentData
     */
    sortBy?: ProductAssortmentDataSortByEnum;
    /**
     * 
     * @type {ProductPublicationReadMetadata}
     * @memberof ProductAssortmentData
     */
    productPublication?: ProductPublicationReadMetadata | null;
}


/**
 * @export
 */
export const ProductAssortmentDataModeEnum = {
    Gross: 'gross',
    Net: 'net'
} as const;
export type ProductAssortmentDataModeEnum = typeof ProductAssortmentDataModeEnum[keyof typeof ProductAssortmentDataModeEnum];

/**
 * @export
 */
export const ProductAssortmentDataSortByEnum = {
    Turnover: 'turnover',
    Amount: 'amount'
} as const;
export type ProductAssortmentDataSortByEnum = typeof ProductAssortmentDataSortByEnum[keyof typeof ProductAssortmentDataSortByEnum];


/**
 * Check if a given object implements the ProductAssortmentData interface.
 */
export function instanceOfProductAssortmentData(value: object): value is ProductAssortmentData {
    return true;
}

export function ProductAssortmentDataFromJSON(json: any): ProductAssortmentData {
    return ProductAssortmentDataFromJSONTyped(json, false);
}

export function ProductAssortmentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAssortmentData {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': json['summary'] == null ? undefined : ProductAssortmentSummaryDataFromJSON(json['summary']),
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(ProductDataFromJSON)),
        'topProducts': json['topProducts'] == null ? undefined : ((json['topProducts'] as Array<any>).map(ProductDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'productPublication': json['productPublication'] === undefined ? undefined : json['productPublication'] === null ? null : ProductPublicationReadMetadataFromJSON(json['productPublication']),
    };
}

export function ProductAssortmentDataToJSON(json: any): ProductAssortmentData {
    return ProductAssortmentDataToJSONTyped(json, false);
}

export function ProductAssortmentDataToJSONTyped(value?: ProductAssortmentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'summary': ProductAssortmentSummaryDataToJSON(value['summary']),
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(ProductDataToJSON)),
        'topProducts': value['topProducts'] == null ? undefined : ((value['topProducts'] as Array<any>).map(ProductDataToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'totalItems': value['totalItems'],
        'totalPages': value['totalPages'],
        'mode': value['mode'],
        'sortBy': value['sortBy'],
        'productPublication': ProductPublicationReadMetadataToJSON(value['productPublication']),
    };
}

